import ZiniHubAdminPrototype from "./ZiniHubAdminPrototype";

export default ZiniHubAdminPrototype;
